import React from 'react'
import { PropTypes } from 'prop-types'
import { useSelector } from 'react-redux'
import lang from './services/Lang'

const TranslatableLink = (props) => {

    const { elementId, linkKey, className, children } = props

    const href = useSelector(state => lang.getValue(linkKey, state.layout.lang))

    return (<a id={elementId} href={href} target='_blank' className={className}>{children}</a>)
}

TranslatableLink.propTypes = {
    elementId: PropTypes.string.isRequired,
    linkKey: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired
}

export default TranslatableLink